import * as React from 'react';
// next
import NextLink from 'next/link';
// layouts
import Layout from '../layouts';
// componentes
import Page from '../components/Page';

// ----------------------------------------------------------------------
// Pagina 500 - migrada do MUI para o visual novo (tokens --gps-*).
//
// Mesma decisao da 404: a ilustracao MUI (SeverErrorIllustration) foi trocada
// por um bloco tipografico, ja que o arquivo fonte e MUI puro e nao tem
// substituto no design novo.
// ----------------------------------------------------------------------

Page500.getLayout = function getLayout(page: React.ReactNode) {
  return <Layout variant="logoOnly">{page}</Layout>;
};

// ----------------------------------------------------------------------

export default function Page500() {
  return (
    <Page title="500 Internal Server Error">
      <div className="flex min-h-full items-center justify-center bg-fundo px-4 py-24">
        <div className="mx-auto max-w-[480px] text-center">
          <span className="text-6xl font-extrabold tabular-nums text-faint">500</span>

          <h1 className="mt-3 text-xl font-extrabold tracking-[-0.02em] text-ink">Erro interno do servidor</h1>

          <p className="mt-2 text-[12.5px] text-muted-foreground">
            Ocorreu um erro, por favor tente novamente mais tarde.
          </p>

          <NextLink
            href="/"
            className="mt-8 inline-flex h-10 items-center justify-center rounded-lg bg-primary px-5 text-[12.5px] font-bold text-primary-foreground no-underline"
          >
            Ir para Home
          </NextLink>
        </div>
      </div>
    </Page>
  );
}
